import { Link } from 'react-router-dom';
import Breadcrumb from '../components/layout/Breadcrumb';
import OnThisPage, { ON_THIS_PAGE_LAYOUT } from '../components/layout/OnThisPage';
import Card from '../components/ui/Card';
import { usePageTitle } from '../hooks/usePageTitle';
import { useScrollSpy } from '../hooks/useScrollSpy';
import {
  ABOUT_GOALS,
  ABOUT_INTRO,
  ABOUT_MISSION,
  ABOUT_PERSONNEL,
  ABOUT_SECTIONS,
  ABOUT_VALUES,
  ABOUT_VISION,
} from '../content/about';

const sectionIds = ABOUT_SECTIONS.map((section) => section.id);

export default function About() {
  usePageTitle('About Us');
  const activeSectionId = useScrollSpy(sectionIds);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumb items={[{ label: 'Home', to: '/' }, { label: 'About Us' }]} />
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">About Us</h1>

      <div className={ON_THIS_PAGE_LAYOUT}>
        <OnThisPage items={ABOUT_SECTIONS} activeId={activeSectionId} />
        <div className="min-w-0 space-y-12">
          <section id="about" className="scroll-mt-24">
            <p className="text-lg text-gray-700 leading-relaxed">{ABOUT_INTRO}</p>
          </section>

          <section id="goals" className="scroll-mt-24">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">
              ORBCoN’s Strategic Goals with Highlighted Projects
            </h2>
            <div className="grid gap-6 md:grid-cols-2">
              {ABOUT_GOALS.map((goal, index) => (
                <Card key={goal.title} className={index === ABOUT_GOALS.length - 1 ? 'md:col-span-2' : ''}>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">{goal.title}</h3>
                  <ul className="list-disc pl-5 space-y-1 text-gray-700">
                    {goal.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </Card>
              ))}
            </div>
          </section>

          <section id="mission" className="scroll-mt-24">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Mission, Vision, and Values</h2>
            <div className="grid gap-6 md:grid-cols-2 mb-6">
              <Card>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Mission</h3>
                <p className="text-gray-700 leading-relaxed">{ABOUT_MISSION}</p>
              </Card>
              <Card>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Vision</h3>
                <p className="text-gray-700 leading-relaxed">{ABOUT_VISION}</p>
              </Card>
            </div>
            <Card className="!p-0 overflow-hidden">
              <h3 className="text-lg font-semibold text-gray-900 px-6 pt-6">Values</h3>
              <ul className="mt-4 divide-y divide-gray-200">
                {ABOUT_VALUES.map((value) => (
                  <li key={value.label} className="px-6 py-4">
                    <p className="font-semibold text-gray-900">{value.label}</p>
                    <p className="text-gray-700 mt-1">{value.text}</p>
                  </li>
                ))}
              </ul>
            </Card>
          </section>

          <section id="personnel" className="scroll-mt-24">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Network Personnel</h2>
            <Card>
              <p className="text-gray-700 leading-relaxed">{ABOUT_PERSONNEL}</p>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center mt-6 px-6 py-3 rounded-md font-medium bg-primary text-white hover:bg-primary-dark focus-ring"
              >
                View contact information
              </Link>
            </Card>
          </section>
        </div>
      </div>
    </div>
  );
}
